<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w0hn09/tc-custom/9781595549457.jpg?1726574123462" alt="This image is the cover for the book Darkness Rising, The East Salem Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Darkness Rising, The East Salem Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The evil in East Salem is no longer content to hide in the shadows. The stakes—and the darkness—are rising.</b></p><p>Dani Harris thought there wasn’t much left that could surprise her after serving as a forensic psychiatrist in East Salem. And Tommy Gunderson has faced few challenges in his life that he couldn’t overcome by either physical strength or his celebrity status.</p><p><br/>But as they race to uncover what’s really happening behind the high walls of St. Adrian’s Academy, it becomes clear that supernatural forces have been at work here for generations. And now their focus is on making sure Dani and Tommy don’t interfere.</p><p>When the unseen becomes seen, faith is the only weapon strong enough to fight in a battle involving not just murder and betrayal—but angels and demons.</p><p>“Wiehl’s latest is a truly creepy story with supernatural undertones that seem eerily real.”  <i>-Romantic Times </i>review of <i>Waking Hours</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lis Wiehl, Pete Nelson
      </h2>
      
      <p class="authorDescription body article"><P><I>New York Times</I> bestselling author Lis Wiehl is the former legal analyst for Fox News&#160;and the&#160;<I>O</I>&rsquo;<I>Reilly</I><I> Factor</I>&#160;and has appeared regularly on&#160;<I>Your World with Neil Cavuto</I>,&#160;<I>Lou Dobbs Tonight</I>, and the Imus morning shows. The former cohost of WOR radio's <I>WOR Tonight with Joe Concha and Lis Wiehl</I>, she has served as legal analyst and reporter for NBC News and NPR's&#160;<I>All Things Considered</I>, as a federal prosecutor in the United States Attorney's office, and as a tenured professor of law at the University of Washington.&#160;She appears frequently on CNN as a legal analyst.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a0fee24